export default __webpack_public_path__ + "2a7b479425552f46fe521f3f0bb46b6e.png";